// Seed data for development and initial setup

export const heroSlides = [
  {
    id: '1',
    title: 'Welcome to DLBC Clarksville TN',
    subtitle: 'A Disciple Making Church - Experience God\'s transforming power',
    imageUrl: 'https://images.unsplash.com/photo-1438232992991-995b7058bbb3?w=1920',
    videoUrl: '',
    ctaText: "I'm New Here",
    ctaLink: '/new-here',
    order: 1,
    isActive: true,
  },
  {
    id: '2',
    title: 'Join Us This Sunday',
    subtitle: 'Sunday School at 9:30 AM • Worship Service at 10:30 AM',
    imageUrl: 'https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=1920',
    videoUrl: '',
    ctaText: 'Plan Your Visit',
    ctaLink: '/plan-your-visit',
    order: 2,
    isActive: true,
  },
  {
    id: '3',
    title: 'Grow in Faith Together',
    subtitle: 'Discover community through our ministries and small groups',
    imageUrl: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=1920',
    videoUrl: '',
    ctaText: 'Explore Ministries',
    ctaLink: '/ministries',
    order: 3,
    isActive: true,
  },
]

export const events = [
  {
    id: '1',
    title: 'Sunday Worship Service',
    description: 'Join us for a powerful time of worship, prayer, and the Word of God. All are welcome!',
    date: '2024-12-22',
    time: '10:30 AM',
    endTime: '12:30 PM',
    location: 'Main Sanctuary',
    address: '819 Providence Blvd, Suite B, Clarksville, TN 37042',
    imageUrl: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800',
    category: 'worship',
    capacity: null,
    requiresRSVP: false,
    isPublished: true,
  },
  {
    id: '2',
    title: 'Christmas Eve Service',
    description: 'Celebrate the birth of our Savior with carols, candlelight, and communion. A beautiful evening for the whole family.',
    date: '2024-12-24',
    time: '6:00 PM',
    endTime: '7:30 PM',
    location: 'Main Sanctuary',
    address: '819 Providence Blvd, Suite B, Clarksville, TN 37042',
    imageUrl: 'https://images.unsplash.com/photo-1512389142860-9c449e58a814?w=800',
    category: 'special',
    capacity: 500,
    requiresRSVP: true,
    isPublished: true,
  },
  {
    id: '3',
    title: 'Youth Night',
    description: 'An exciting night for teens with games, worship, and a powerful message. Bring a friend!',
    date: '2024-12-27',
    time: '7:00 PM',
    endTime: '9:00 PM',
    location: 'Youth Center',
    address: '819 Providence Blvd, Suite B, Clarksville, TN 37042',
    imageUrl: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800',
    category: 'youth',
    capacity: 100,
    requiresRSVP: true,
    isPublished: true,
  },
  {
    id: '4',
    title: 'New Year\'s Eve Prayer Vigil',
    description: 'Enter the new year in prayer and worship. Join us as we seek God\'s face and commit the coming year to Him.',
    date: '2024-12-31',
    time: '10:00 PM',
    endTime: '12:30 AM',
    location: 'Main Sanctuary',
    address: '819 Providence Blvd, Suite B, Clarksville, TN 37042',
    imageUrl: 'https://images.unsplash.com/photo-1467810563316-b5476525c0f9?w=800',
    category: 'prayer',
    capacity: null,
    requiresRSVP: false,
    isPublished: true,
  },
]

// YouTube Playlist: https://www.youtube.com/playlist?list=PLhUSSHKj-nG_f2IOOj6Au917Juj0lVVcl
// To add more sermons, copy the video URL from the playlist and add a new entry below
export const sermons = [
  {
    id: '1',
    title: 'Sunday Worship Service',
    speaker: 'Pastor W.F. Kumuyi',
    series: 'Sunday Service',
    date: '2024-12-15',
    youtubeUrl: 'https://www.youtube.com/playlist?list=PLhUSSHKj-nG_f2IOOj6Au917Juj0lVVcl',
    description: 'Join us for our Sunday Worship Service as we gather to praise God and study His Word.',
    scriptures: '',
    notesUrl: '',
    duration: '1:30:00',
    isPublished: true,
  },
  {
    id: '2',
    title: 'Bible Study - Faith That Moves Mountains',
    speaker: 'DLBC Clarksville',
    series: 'Bible Study',
    date: '2024-12-10',
    youtubeUrl: 'https://www.youtube.com/playlist?list=PLhUSSHKj-nG_f2IOOj6Au917Juj0lVVcl',
    description: 'A deep dive into the Scriptures exploring the power of faith in the life of a believer.',
    scriptures: 'Hebrews 11:1-6',
    notesUrl: '',
    duration: '1:00:00',
    isPublished: true,
  },
  {
    id: '3',
    title: 'Revival Hour - Walking in Holiness',
    speaker: 'DLBC Clarksville',
    series: 'Revival Hour',
    date: '2024-12-06',
    youtubeUrl: 'https://www.youtube.com/playlist?list=PLhUSSHKj-nG_f2IOOj6Au917Juj0lVVcl',
    description: 'Experience the presence of God as we seek revival and renewal in our walk with Christ.',
    scriptures: '1 Peter 1:15-16',
    notesUrl: '',
    duration: '1:15:00',
    isPublished: true,
  },
  {
    id: '4',
    title: 'Sunday Worship - The Gospel to Every Creature',
    speaker: 'Pastor W.F. Kumuyi',
    series: 'Sunday Service',
    date: '2024-12-01',
    youtubeUrl: 'https://www.youtube.com/playlist?list=PLhUSSHKj-nG_f2IOOj6Au917Juj0lVVcl',
    description: 'Understanding our mandate to spread the Gospel of Jesus Christ to all nations.',
    scriptures: 'Mark 16:15',
    notesUrl: '',
    duration: '1:45:00',
    isPublished: true,
  },
  {
    id: '5',
    title: 'Bible Study - Living by the Spirit',
    speaker: 'DLBC Clarksville',
    series: 'Bible Study',
    date: '2024-11-26',
    youtubeUrl: 'https://www.youtube.com/playlist?list=PLhUSSHKj-nG_f2IOOj6Au917Juj0lVVcl',
    description: 'Understanding the role of the Holy Spirit in our daily lives and how to walk in the Spirit.',
    scriptures: 'Galatians 5:16-25',
    notesUrl: '',
    duration: '1:00:00',
    isPublished: true,
  },
  {
    id: '6',
    title: 'Revival Hour - Power of Prayer',
    speaker: 'DLBC Clarksville',
    series: 'Revival Hour',
    date: '2024-11-22',
    youtubeUrl: 'https://www.youtube.com/playlist?list=PLhUSSHKj-nG_f2IOOj6Au917Juj0lVVcl',
    description: 'Discover the transformative power of prayer and how it connects us with God.',
    scriptures: 'James 5:16',
    notesUrl: '',
    duration: '1:20:00',
    isPublished: true,
  },
]

export const ministries = [
  {
    id: '1',
    name: 'Men\'s Fellowship',
    description: 'Building godly men through Bible study, fellowship, and accountability. Join us as we grow together in faith and leadership.',
    category: 'men',
    leaderName: 'Brother Michael Johnson',
    schedule: 'Every Saturday at 7:00 AM',
    location: 'Fellowship Hall',
    imageUrl: '/images/mens-fellowship.png',
    isActive: true,
  },
  {
    id: '2',
    name: 'Women\'s Ministry',
    description: 'Empowering women to grow in Christ, support one another, and impact their families and communities for God\'s glory.',
    category: 'women',
    leaderName: 'Sister Mary Adebayo',
    schedule: 'First Saturday of each month at 9:00 AM',
    location: 'Women\'s Center',
    imageUrl: '/images/womens-ministry.jpg',
    isActive: true,
  },
  {
    id: '3',
    name: 'Young Adults',
    description: 'A vibrant community for young adults (ages 18-35) to connect, grow in faith, and navigate life\'s journey together. Join us for engaging discussions, fellowship, and spiritual growth.',
    category: 'youth',
    leaderName: 'Brother David Okafor',
    schedule: 'Fridays at 7:00 PM',
    location: 'Fellowship Hall',
    imageUrl: '/images/young-adults.png',
    isActive: true,
  },
  {
    id: '4',
    name: 'DLBC Campus Fellowship',
    description: 'Connecting college and university students with Christ and each other. A place for students to find community, grow spiritually, and be equipped to impact their campuses for the Kingdom.',
    category: 'campus',
    leaderName: 'Brother Samuel Eze',
    schedule: 'Wednesdays at 6:00 PM',
    location: 'Campus Center',
    imageUrl: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800',
    isActive: true,
  },
  {
    id: '5',
    name: 'Small Groups',
    description: 'Have you given your life to Christ, but need an environment where you can grow and develop in your faith? Join any of our small groups to build your faith in the Lord.',
    category: 'groups',
    leaderName: 'Various Leaders',
    schedule: 'Multiple times throughout the week',
    location: 'Various Locations',
    imageUrl: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800',
    isActive: true,
  },
  {
    id: '6',
    name: 'Community Engagement Connect',
    description: 'Reaching out to our community with the love of Christ through service projects, outreach events, and building meaningful relationships. Be the hands and feet of Jesus in Clarksville.',
    category: 'outreach',
    leaderName: 'Brother James Wilson',
    schedule: 'Monthly outreach events',
    location: 'Various Locations',
    imageUrl: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=800',
    isActive: true,
  },
]

export const smallGroups = [
  {
    id: '1',
    name: 'Young Adults Bible Study',
    description: 'For ages 18-30. Deep dive into Scripture with peers navigating similar life stages.',
    day: 'Tuesday',
    time: '7:00 PM',
    location: 'Church Library',
    leader: 'Brother Daniel Eze',
    demographic: 'Young Adults',
  },
  {
    id: '2',
    name: 'Couples Connection',
    description: 'Strengthening marriages through biblical principles and mutual support.',
    day: 'Thursday',
    time: '7:00 PM',
    location: 'Fellowship Hall',
    leader: 'Pastor & Sister Adebayo',
    demographic: 'Married Couples',
  },
  {
    id: '3',
    name: 'Women of Faith',
    description: 'A supportive space for women to grow in Christ and encourage one another.',
    day: 'Wednesday',
    time: '10:00 AM',
    location: 'Women\'s Center',
    leader: 'Sister Patricia Okonkwo',
    demographic: 'Women',
  },
  {
    id: '4',
    name: 'Men\'s Iron Sharpens Iron',
    description: 'Men challenging men to be godly leaders in their homes and communities.',
    day: 'Saturday',
    time: '8:00 AM',
    location: 'Fellowship Hall',
    leader: 'Brother Michael Johnson',
    demographic: 'Men',
  },
  {
    id: '5',
    name: 'New Believers',
    description: 'Foundation building for those new to the faith. Learn the basics of following Christ.',
    day: 'Sunday',
    time: '9:30 AM',
    location: 'Room 102',
    leader: 'Deacon Samuel Nwosu',
    demographic: 'New Believers',
  },
]

export const team = [
  {
    id: '1',
    name: 'Pastor John Adebayo',
    role: 'Senior Pastor',
    bio: 'Pastor John has been serving as the Senior Pastor of DLBC Clarksville for over 15 years. His passion is teaching the uncompromising Word of God and seeing lives transformed by the power of the Gospel.',
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    email: 'pastor@dlbcclarksville.org',
    order: 1,
    isPublished: true,
  },
  {
    id: '2',
    name: 'Sister Mary Adebayo',
    role: 'Pastor\'s Wife & Women\'s Ministry Leader',
    bio: 'Sister Mary leads the Women\'s Ministry with grace and wisdom. She is passionate about discipling women and helping them discover their purpose in Christ.',
    imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400',
    email: '',
    order: 2,
    isPublished: true,
  },
  {
    id: '3',
    name: 'Minister Grace Okonkwo',
    role: 'Associate Pastor',
    bio: 'Minister Grace oversees pastoral care and coordinates church programs. She has a heart for counseling and helping members navigate life\'s challenges with faith.',
    imageUrl: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400',
    email: 'grace@dlbcclarksville.org',
    order: 3,
    isPublished: true,
  },
  {
    id: '4',
    name: 'Brother David Okafor',
    role: 'Youth Pastor',
    bio: 'Brother David leads our vibrant youth ministry. His energy and passion for the next generation is contagious, and he\'s committed to raising up young disciples.',
    imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400',
    email: 'youth@dlbcclarksville.org',
    order: 4,
    isPublished: true,
  },
  {
    id: '5',
    name: 'Brother Emmanuel Obi',
    role: 'Worship Leader',
    bio: 'Brother Emmanuel leads our worship team with excellence and a heart for God\'s presence. He believes worship is the doorway to encountering God.',
    imageUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
    email: 'worship@dlbcclarksville.org',
    order: 5,
    isPublished: true,
  },
  {
    id: '6',
    name: 'Deacon Samuel Nwosu',
    role: 'Church Administrator',
    bio: 'Deacon Samuel manages church operations and ensures everything runs smoothly. His servant heart and organizational skills are a blessing to our church.',
    imageUrl: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400',
    email: 'admin@dlbcclarksville.org',
    order: 6,
    isPublished: true,
  },
]

export const beliefs = [
  {
    title: 'The Holy Scriptures',
    description: 'The Holy Bible, consisting of the 39 books of the Old Testament and 27 books of the New Testament, is the inspired Word of God and the final authority for all Christian faith and practice.',
    scripture: '2 Timothy 3:16-17; 2 Peter 1:20-21',
  },
  {
    title: 'The Godhead',
    description: 'There is one God, eternally existent in three distinct personalities: God the Father, God the Son, and God the Holy Ghost, united as one Godhead.',
    scripture: 'Matthew 28:19; 2 Corinthians 13:14; 1 John 5:7',
  },
  {
    title: 'The Virgin Birth of Jesus Christ',
    description: 'We believe in the virgin birth of Jesus Christ, His sinless life, His miracles, His vicarious and atoning death through His shed blood, His bodily resurrection, His ascension to the right hand of the Father, and His personal return in power and glory.',
    scripture: 'Isaiah 7:14; Matthew 1:23; Luke 1:35; Hebrews 4:15',
  },
  {
    title: 'Human Depravity',
    description: 'All human beings are born with a sinful nature and are sinners by practice, therefore subject to God\'s wrath and in need of salvation.',
    scripture: 'Romans 3:10-23; Romans 5:12; Ephesians 2:1-3',
  },
  {
    title: 'Repentance',
    description: 'Repentance, which is a complete turning away from sin, is necessary before saving faith can be exercised. It involves godly sorrow for sin, confession of sin, and a deliberate forsaking of sin.',
    scripture: 'Mark 1:15; Luke 13:3; Acts 3:19; 2 Corinthians 7:10',
  },
  {
    title: 'Restitution',
    description: 'Making amends for wrongs done to others, restoring stolen items, and clearing damaged reputations as far as possible, is a fruit of genuine repentance.',
    scripture: 'Ezekiel 33:15; Matthew 3:8; Luke 19:8',
  },
  {
    title: 'Justification',
    description: 'Justification is the gracious act of God whereby He declares the repentant sinner righteous upon their faith in Christ and His atoning blood. It results in forgiveness of sins and the imputation of Christ\'s righteousness.',
    scripture: 'Romans 3:24-26; Romans 5:1; Galatians 2:16',
  },
  {
    title: 'Water Baptism',
    description: 'Water baptism by one immersion in the name of the Father, Son, and Holy Ghost is commanded for all who have repented and believed in Christ as Savior and Lord.',
    scripture: 'Matthew 28:19; Acts 2:38; Romans 6:3-4',
  },
  {
    title: 'The Lord\'s Supper',
    description: 'The Lord\'s Supper, consisting of unleavened bread and the fruit of the vine, should be observed regularly as a memorial of Christ\'s death and in anticipation of His second coming.',
    scripture: 'Matthew 26:26-29; 1 Corinthians 11:23-26',
  },
  {
    title: 'Entire Sanctification',
    description: 'Entire sanctification is a definite work of grace, subsequent to regeneration, by which the heart is purified from all inward sin and filled with the pure love of God. It is wrought by the baptism with the Holy Ghost and is obtained through faith in Christ.',
    scripture: 'Acts 15:8-9; 1 Thessalonians 5:23-24; Hebrews 13:12',
  },
  {
    title: 'The Baptism of the Holy Ghost',
    description: 'The baptism of the Holy Ghost is an enduement of power upon the sanctified believer for service, with the initial evidence of speaking in other tongues as the Spirit gives utterance.',
    scripture: 'Luke 24:49; Acts 1:8; Acts 2:4; Acts 10:44-46',
  },
  {
    title: 'Divine Healing',
    description: 'Redemption from sickness and healing for the body is provided for in the atonement of Christ, and is the privilege of all believers who exercise faith.',
    scripture: 'Isaiah 53:4-5; Matthew 8:16-17; James 5:14-16; 1 Peter 2:24',
  },
  {
    title: 'Personal Evangelism',
    description: 'Personal evangelism and soul winning is the God-ordained duty of every believer. We are called to be witnesses of Christ to the ends of the earth.',
    scripture: 'Proverbs 11:30; Matthew 28:19-20; Acts 1:8',
  },
  {
    title: 'Christian Marriage',
    description: 'Marriage is a lifelong, monogamous union between one man and one woman as ordained by God. Remarriage while a former spouse is still living is not permitted except on the grounds of fornication.',
    scripture: 'Genesis 2:24; Matthew 19:4-9; Mark 10:6-12; Romans 7:2-3',
  },
  {
    title: 'The Rapture',
    description: 'The rapture is the catching away of all true believers to meet the Lord in the air before the Great Tribulation. Only those who are watching and ready will be taken.',
    scripture: 'Matthew 24:40-44; 1 Corinthians 15:51-52; 1 Thessalonians 4:16-17',
  },
  {
    title: 'The Resurrection of the Dead',
    description: 'There will be a bodily resurrection of all the dead - both the just and the unjust - to face eternal judgment.',
    scripture: 'John 5:28-29; Acts 24:15; Revelation 20:12-13',
  },
  {
    title: 'The Great Tribulation',
    description: 'The Great Tribulation will be a time of unprecedented terror and suffering upon the earth after the rapture of the saints, during which the Antichrist will reign.',
    scripture: 'Daniel 12:1; Matthew 24:21-22; Revelation 7:14',
  },
  {
    title: 'The Second Coming of Christ',
    description: 'The second coming of Christ is the literal, visible return of Jesus Christ to the earth to destroy the Antichrist, judge the nations, and establish His millennial kingdom.',
    scripture: 'Zechariah 14:4; Matthew 24:30; Revelation 19:11-16',
  },
  {
    title: 'Christ\'s Millennial Reign',
    description: 'Christ will reign literally on earth for 1,000 years with His saints. During this time, Satan will be bound, and righteousness and peace will prevail.',
    scripture: 'Isaiah 11:6-9; Revelation 20:1-6',
  },
  {
    title: 'The Great White Throne Judgment',
    description: 'After the millennium, all the unsaved dead will be raised and stand before the Great White Throne to be judged according to their works and cast into the lake of fire.',
    scripture: 'Revelation 20:11-15',
  },
  {
    title: 'The New Heaven and New Earth',
    description: 'God will create a new heaven and new earth where the redeemed will dwell eternally in the presence of God, free from sin, sorrow, and death forever.',
    scripture: 'Isaiah 65:17; 2 Peter 3:13; Revelation 21:1-4',
  },
  {
    title: 'Eternal Punishment',
    description: 'Hell is a place of everlasting conscious punishment for the devil, his angels, and all whose names are not found in the Book of Life.',
    scripture: 'Matthew 25:41, 46; Mark 9:43-48; Revelation 20:10, 15',
  },
]

export const testimonials = [
  {
    id: '1',
    name: 'Brother James',
    text: 'Finding DLBC Clarksville was a turning point in my life. The genuine love and powerful teaching here have transformed my walk with God.',
    role: 'Member since 2018',
  },
  {
    id: '2',
    name: 'Sister Angela',
    text: 'This church feels like family. The small groups have helped me grow spiritually and build lasting friendships.',
    role: 'Member since 2020',
  },
  {
    id: '3',
    name: 'Brother Thomas',
    text: 'The depth of biblical teaching here is unmatched. Pastor Adebayo\'s messages challenge and encourage me every week.',
    role: 'Member since 2015',
  },
]

export const historyTimeline = [
  {
    year: '2005',
    title: 'Church Founded',
    description: 'Deeper Life Bible Church Clarksville began with a small group of 15 believers meeting in a living room.',
  },
  {
    year: '2008',
    title: 'First Building',
    description: 'The church moved into its first dedicated building, a small chapel that could seat 100 people.',
  },
  {
    year: '2012',
    title: 'Growth & Expansion',
    description: 'Membership grew to over 200, and additional services were added to accommodate the growing congregation.',
  },
  {
    year: '2016',
    title: 'New Sanctuary',
    description: 'The church built and moved into the current sanctuary, a beautiful facility that seats 500.',
  },
  {
    year: '2020',
    title: 'Online Ministry Launch',
    description: 'Launched online services and ministry, reaching members and seekers across the nation.',
  },
  {
    year: '2024',
    title: 'Continuing the Mission',
    description: 'Today, DLBC Clarksville continues to grow, with over 400 members and multiple ministries serving the community.',
  },
]

export const stats = [
  { label: 'Years Worldwide', value: 50 },
  { label: 'Countries Reached', value: 100 },
  { label: 'US Branches', value: 90 },
  { label: 'Active Ministries', value: 12 },
]
